module.exports = __webpack_public_path__ + "static/media/mecanizado.1f0accbf.png";